import { Operator } from '@jexop/core';
import type { JSX } from 'react';
import { SimpleElement } from '../components';
import { DisplayWithDeleted } from '../types';

export const renderSimpleElement: Operator<(data: DisplayWithDeleted) => JSX.Element> = () => {
  const renderFunction = (d: DisplayWithDeleted): JSX.Element => <SimpleElement data={d}></SimpleElement>;
  return renderFunction;
};
